import { useSelector } from "react-redux";

import { isAuthenticatedSelector } from "store/auth/selectors";

import ModalOffer from "./ModalOffer";

import { useWidgetOptions } from "context/widgetOptions";

import { ModalOfferContainerType } from "./ModalOffer.types";

const ModalOfferContainer = ({
  ...props
}: ModalOfferContainerType) => {
  const options = useWidgetOptions()


  const isAuthenticated = useSelector(isAuthenticatedSelector);

  return (
    <ModalOffer
      isAuthenticated={isAuthenticated}
      modals={options?.modals || {}}
      {...props}
    />
  );
};

export default ModalOfferContainer;
